import React, { useEffect, useState } from "react";
import { PasswordInput, SaveButton, SimpleForm, useNotify } from "react-admin";

import useAuthMutations from "../../store/mutations/useAuthMutations";

import useValidators from "../../hooks/useValidators";

type MfaFormProps = {
  email: string;
  password_digest: string;
  isMfaSetup: boolean;
  isMfaCheck: boolean;
  isMfaCompleted: boolean;
};

const MfaForm: React.FC<MfaFormProps> = ({ email, password_digest, isMfaSetup, isMfaCheck, isMfaCompleted }) => {
  const notify = useNotify();
  const { checkMfa, verifyMfa } = useAuthMutations(notify);
  const { mfa } = useValidators();

  const defaultFormData = {
    email,
    password_digest,
    firstCode: null,
    secondCode: null,
  };

  const [formData, setFormData] = useState(defaultFormData);

  const handleSubmit = () => {
    if (isMfaSetup && formData.firstCode) {
      verifyMfa({ code: formData.firstCode, email: formData.email, password_digest: formData.password_digest });
    }

    if (isMfaCheck && formData.firstCode) {
      checkMfa({ code: formData.firstCode, email: formData.email });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (isMfaCompleted && formData.secondCode) {
      checkMfa({ code: formData.secondCode, email: formData.email });
    }
  }, [isMfaCompleted, formData.secondCode]);

  return (
    <SimpleForm
      className="c-form c-form_mfa"
      onSubmit={handleSubmit}
      id="c-form_mfa"
      toolbar={<SaveButton icon={<></>} className="c-form__submit-btn" label="Check" />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <PasswordInput
        className="c-form__input c-form__input_password"
        label={`${isMfaSetup ? "Authentication code 1" : "Authentication code"}`}
        name="firstCode"
        onChange={handleChange}
        placeholder="Enter code"
        source="firstCode"
        validate={mfa}
        value={formData.firstCode || ""}
      />
      {(isMfaSetup || isMfaCompleted) && (
        <PasswordInput
          className="c-form__input c-form__input_password"
          label="Authentication code 2"
          name="secondCode"
          onChange={handleChange}
          placeholder="Enter code"
          source="secondCode"
          validate={mfa}
          value={formData.secondCode || ""}
        />
      )}
    </SimpleForm>
  );
};

export default MfaForm;
